import Vue from 'vue';
import VueRouter from 'vue-router';

//全局导航守卫
import('./permission');

/**
 * 个人中心
 * **/
//个人中心页面--------------------------------------------
const Profile = () => import('@/views/profile/Profile');

/**
 * 404页面
 * **/
//404页面--------------------------------------------
const page404 = () => import('@/views/error404/Error404');

/**
 * 资源详情展示页面
 * **/
//资源中心内容详情--------------------------------------------
const ResourceDetail = () =>
  import('@/views/resourceDetailView/ResourceDetail');

/**
 * 资源中心
 * **/
//资源中心--------------------------------------------
const ResourceCenter = () => import('@/views/resourceCenter/ResourceCenter');
//资源中心的安道云资源--------------------------------------------
const CloudResource = () =>
  import('@/views/resourceCenter/components/amCloudResource/CloudResource');
//同步教材资源--------------------------------------------
const SyncTextBook = () =>
  import('@/views/resourceCenter/components/syncTextBookResource/SyncTextBook');

/**
 * 题库中心
 * **/
//题库中心--------------------------------------------
const QuestionBankCenter = () =>
  import('@/views/questionBankCenter/QuestionBankCenter');
//题库内容--------------------------------------------
const QuestionBankCon = () =>
  import('@/views/questionBankCenter/components/questionBank/QuestionBankCon');

/**
 * 卷库中心
 * **/
//卷库中心--------------------------------------------
const PaperCenter = () => import('@/views/paperCenter/PaperCenter');
//卷库--------------------------------------------
const VolumeLibrary = () =>
  import('@/views/paperCenter/components/volumeLibrary/VolumeLibrary');

/**
 * 云课中心
 * **/
//云课中心--------------------------------------------
const CloudClassCenter = () =>
  import('@/views/cloudClassCenter/CloudClassCenter');
//点播课堂--------------------------------------------
const DemandRoom = () =>
  import('@/views/cloudClassCenter/components/onDemandClassRoom/DemandRoom');
//1+N互动课堂--------------------------------------------
const InteractiveRoom = () =>
  import(
    '@/views/cloudClassCenter/components/InteractiveClassRoom/InteractiveRoom'
  );
//直播课堂--------------------------------------------
const LiveRoom = () =>
  import('@/views/cloudClassCenter/components/LiveClassRoom/LiveRoom');
//视频播放页面--------------------------------------------
const VideoPage = () =>
  import('@/views/cloudClassCenter/components/videoPlayPage/VideoPage');

/**
 * 图书中心
 * **/
//电子书--------------------------------------------
const EBook = () => import('@/views/eBook/EBook');
//电子教材--------------------------------------------
const ETextBook = () => import('@/views/eBook/components/eTextbook/ETextBook');
//电子图书--------------------------------------------
const DigitalBook = () =>
  import('@/views/eBook/components/digitalBook/DigitalBook');

/**
 * 应用中心
 * **/
//应用中心--------------------------------------------
const AppCenter = () => import('@/views/appCenter/AppCenter');
//绿色应用--------------------------------------------
const GreenApp = () => import('@/views/appCenter/components/greenApp/GreenApp');

Vue.use(VueRouter);
const routes = [
  {
    path: '/',
    redirect: '/resource-center',
  },
  //资源中心--------------------------------------------
  {
    path: '/resource-center',
    name: 'ResourceCenter',
    component: ResourceCenter,
    //默认路径
    redirect: '/resource-center/cloud-resource',
    children: [
      {
        path: 'cloud-resource',
        name: 'CloudResource',
        component: CloudResource,
      },
      {
        path: 'sync-textbook',
        name: 'SyncTextBook',
        component: SyncTextBook,
      },
    ],
  },
  //资源内容详情--------------------------------------------
  {
    path: '/resource-detail',
    name: 'ResourceDetail',
    component: ResourceDetail,
  },
  //题库中心--------------------------------------------
  {
    path: '/question-bank',
    name: 'QuestionBank',
    component: QuestionBankCenter,
    //默认路径
    redirect: '/question-bank/question-bank-con',
    children: [
      {
        path: 'question-bank-con',
        name: 'QuestionBankCon',
        component: QuestionBankCon,
      },
    ],
  },
  //云课中心--------------------------------------------
  {
    path: '/cloud-class',
    name: 'CloudClass',
    component: CloudClassCenter,
    //默认路径
    redirect: '/cloud-class/demand-room',
    children: [
      {
        path: 'demand-room',
        name: 'DemandRoom',
        component: DemandRoom,
      },
      {
        path: 'interactive-room',
        name: 'InteractiveRoom',
        component: InteractiveRoom,
      },
      {
        path: 'live-room',
        name: 'LiveRoom',
        component: LiveRoom,
      },
      {
        path: 'video-page',
        name: 'VideoPage',
        component: VideoPage,
        meta: {
          //是否显示轮播图--------------------------------------------
          isSwiper: true,
          //是否显示子级导航栏--------------------------------------------
          isSecondaryNav: true,
        },
      },
    ],
  },
  //电子图书--------------------------------------------
  {
    path: '/e-book',
    name: 'EBook',
    component: EBook,
    //默认路径
    redirect: '/e-book/e-textbook',
    children: [
      {
        path: 'e-textbook',
        name: 'ETextBook',
        component: ETextBook,
      },
      {
        path: 'digital-book',
        name: 'DigitalBook',
        component: DigitalBook,
      },
    ],
  },
  //应用中心--------------------------------------------
  {
    path: '/app-center',
    name: 'AppCenter',
    component: AppCenter,
    //默认路径
    redirect: '/app-center/green-app',
    children: [
      {
        path: 'green-app',
        name: 'GreenApp',
        component: GreenApp,
      },
    ],
  },
  //卷库中心--------------------------------------------
  {
    path: '/paper-center',
    name: 'PaperCenter',
    component: PaperCenter,
    //默认路径
    redirect: '/paper-center/volume-library',
    children: [
      {
        path: 'volume-library',
        name: 'VolumeLibrary',
        component: VolumeLibrary,
      },
    ],
  },
  //我的页面
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    redirect: '/profile/my-collection',
    meta: {
      needLogin: true,
    },
    children: [
      //我的上传--------------------------------------------
      {
        path: 'my-upload',
        name: 'MyUpload',
        component: () =>
          import('@/views/profile/components/mine/myUpload/MyUpload'),
        redirect: '/profile/my-upload/up-digital-books',
        meta: {
          needLogin: true,
        },
        children: [
          //教材--------------------------------------------
          {
            path: 'up-textbook',
            name: 'UpTextbook',
            component: () =>
              import(
                '@/views/profile/components/mine/myUpload/eTextbook/UpTextbook'
              ),
          },
          //教案--------------------------------------------
          {
            path: 'up-teaching-plan',
            name: 'UpTeachingPlan',
            component: () =>
              import(
                '@/views/profile/components/mine/myUpload/teachingPlan/UpTeachingPlan'
              ),
          },
          //试卷--------------------------------------------
          {
            path: 'up-test-paper',
            name: 'UpTestPaper',
            component: () =>
              import(
                '@/views/profile/components/mine/myUpload/testPaper/UpTestPaper'
              ),
          },
          //应用--------------------------------------------
          {
            path: 'up-application',
            name: 'UpApplication',
            component: () =>
              import(
                '@/views/profile/components/mine/myUpload/application/UpApplication'
              ),
          },
          //图书--------------------------------------------
          {
            path: 'up-digital-books',
            name: 'UpDigitalBooks',
            component: () =>
              import(
                '@/views/profile/components/mine/myUpload/digitalBooks/UpDigitalBooks'
              ),
          },
          //课件--------------------------------------------
          {
            path: 'up-courseware',
            name: 'UpCourseware',
            component: () =>
              import(
                '@/views/profile/components/mine/myUpload/courseware/UpCourseware'
              ),
          },
          //图片--------------------------------------------
          {
            path: 'up-picture',
            name: 'UpPicture',
            component: () =>
              import(
                '@/views/profile/components/mine/myUpload/picture/UpPicture'
              ),
          },
          //视频--------------------------------------------
          {
            path: 'up-video',
            name: 'UpVideo',
            component: () =>
              import('@/views/profile/components/mine/myUpload/video/UpVideo'),
          },
          //视频课程--------------------------------------------
          {
            path: 'up-video-course',
            name: 'UpVideoCourse',
            component: () =>
              import(
                '@/views/profile/components/mine/myUpload/videoCourse/UpVideoCourse'
              ),
          },
          //动画--------------------------------------------
          {
            path: 'up-animation',
            name: 'UpAnimation',
            component: () =>
              import(
                '@/views/profile/components/mine/myUpload/animation/UpAnimation'
              ),
          },
          //音频--------------------------------------------
          {
            path: 'up-audio',
            name: 'UpAudio',
            component: () =>
              import('@/views/profile/components/mine/myUpload/audio/UpAudio'),
          },
          //练习--------------------------------------------
          {
            path: 'up-exercise',
            name: 'UpExercise',
            component: () =>
              import(
                '@/views/profile/components/mine/myUpload/exercise/UpExercise'
              ),
          },
          //其他--------------------------------------------
          {
            path: 'up-other',
            name: 'UpOther',
            component: () =>
              import('@/views/profile/components/mine/myUpload/other/UpOther'),
          },
        ],
      },
      //我的收藏--------------------------------------------
      {
        path: 'my-collection',
        name: 'MyCollection',
        component: () =>
          import('@/views/profile/components/mine/myCollection/MyCollection'),
        redirect: '/profile/my-collection/co-digital-books',
        children: [
          //教材--------------------------------------------
          {
            path: 'co-textbook',
            name: 'CoTextbook',
            component: () =>
              import(
                '@/views/profile/components/mine/myCollection/eTextbook/CoTextbook'
              ),
          },
          //教案--------------------------------------------
          {
            path: 'co-teaching-plan',
            name: 'CoTeachingPlan',
            component: () =>
              import(
                '@/views/profile/components/mine/myCollection/teachingPlan/CoTeachingPlan'
              ),
          },
          //试卷--------------------------------------------
          {
            path: 'co-test-paper',
            name: 'CoTestPaper',
            component: () =>
              import(
                '@/views/profile/components/mine/myCollection/testPaper/CoTestPaper'
              ),
          },
          //应用--------------------------------------------
          {
            path: 'co-application',
            name: 'CoApplication',
            component: () =>
              import(
                '@/views/profile/components/mine/myCollection/application/CoApplication'
              ),
          },
          //图书--------------------------------------------
          {
            path: 'co-digital-books',
            name: 'CoDigitalBooks',
            component: () =>
              import(
                '@/views/profile/components/mine/myCollection/digitalBooks/CoDigitalBooks'
              ),
          },
          //课件--------------------------------------------
          {
            path: 'co-courseware',
            name: 'CoCourseware',
            component: () =>
              import(
                '@/views/profile/components/mine/myCollection/courseware/CoCourseware'
              ),
          },
          //图片--------------------------------------------
          {
            path: 'co-picture',
            name: 'CoPicture',
            component: () =>
              import(
                '@/views/profile/components/mine/myCollection/picture/CoPicture'
              ),
          },
          //视频--------------------------------------------
          {
            path: 'co-video',
            name: 'CoVideo',
            component: () =>
              import(
                '@/views/profile/components/mine/myCollection/video/CoVideo'
              ),
          },
          //视频课程--------------------------------------------
          {
            path: 'co-video-course',
            name: 'CoVideoCourse',
            component: () =>
              import(
                '@/views/profile/components/mine/myCollection/videoCourse/CoVideoCourse'
              ),
          },
          //动画--------------------------------------------
          {
            path: 'co-animation',
            name: 'CoAnimation',
            component: () =>
              import(
                '@/views/profile/components/mine/myCollection/animation/CoAnimation'
              ),
          },
          //音频--------------------------------------------
          {
            path: 'co-audio',
            name: 'CoAudio',
            component: () =>
              import(
                '@/views/profile/components/mine/myCollection/audio/CoAudio'
              ),
          },
          //练习--------------------------------------------
          {
            path: 'co-exercise',
            name: 'CoExercise',
            component: () =>
              import(
                '@/views/profile/components/mine/myCollection/exercise/CoExercise'
              ),
          },
          //其他--------------------------------------------
          {
            path: 'co-other',
            name: 'CoOther',
            component: () =>
              import(
                '@/views/profile/components/mine/myCollection/other/CoOther'
              ),
          },
        ],
      },
      //设置信息--------------------------------------------
      {
        path: 'set-info',
        name: 'SetInfo',
        component: () =>
          import('@/views/profile/components/profileSet/setInfo/SetInfo'),
        redirect: '/profile/set-info/basic-info',
        children: [
          //基本信息--------------------------------------------
          {
            path: 'basic-info',
            name: 'BasicInfo',
            component: () =>
              import(
                '@/views/profile/components/profileSet/setInfo/basicInfo/BasicInfo'
              ),
          },
          //身份信息--------------------------------------------
          {
            path: 'identity-info',
            name: 'IdentityInfo',
            component: () =>
              import(
                '@/views/profile/components/profileSet/setInfo/identityInfo/IdentityInfo'
              ),
          },
        ],
      },
      //设置账户--------------------------------------------
      {
        path: 'set-account',
        name: 'SetAccount',
        component: () =>
          import('@/views/profile/components/profileSet/setAccount/SetAccount'),
        redirect: '/profile/set-account/account-bind',
        children: [
          {
            path: 'account-bind',
            name: 'AccountBind',
            component: () =>
              import(
                '@/views/profile/components/profileSet/setAccount/accountBind/AccountBind'
              ),
          },
          {
            path: 'account-security',
            name: 'AccountSecurity',
            component: () =>
              import(
                '@/views/profile/components/profileSet/setAccount/accountSecurity/AccountSecurity'
              ),
          },
        ],
      },
    ],
  },
  //登录页
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/Login'),
    meta: {
      isTopNav: true,
      isSideToolBar: true,
      isFooterContent: true,
    },
  },
  //用户协议
  {
    path: '/agreement',
    name: 'Agreement',
    component: () => import('@/views/agreement/Agreement.vue'),
    meta: {
      isTopNav: true,
      isSideToolBar: true,
      isFooterContent: true,
    },
  },
  //404页面
  {
    path: '*',
    name: '404Page',
    component: page404,
    meta: {
      isTopNav: true,
      isSideToolBar: true,
      isFooterContent: true,
    },
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  // mode:'history'
  //组件切换回到顶部
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0,
    };
  },
});

export default router;
